import { useRouter } from "next/router";
import logger from "@airhelp/node-logger";
import { Schema } from "components/Schema";
import getUrlFromLink from "utils/getUrlFromLink";
import createBreadcrumbsSchema from "utils/createBreadcrumbsSchema";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import type { LanguageCode } from "config/languages";
import type { BreadcrumbsSchemaProps } from "./BreadcrumbsSchema.d";

const BreadcrumbsSchema = ({ breadcrumbsPositionName, breadcrumbsParentPage }: BreadcrumbsSchemaProps) => {
  const {
    asPath: pagePath,
    query: { language },
  } = useRouter();
  if (!breadcrumbsPositionName) return null;
  const domain = getDomainFromLanguage(language as LanguageCode);

  const currentUrl = `${domain}${pagePath}`;
  const firstElementUrl = `${domain}/${language}/`;
  const parentPositionName = breadcrumbsParentPage?.story?.content.breadcrumbsPositionName || "";
  const parentPageFullSlug = getUrlFromLink(breadcrumbsParentPage);
  const parentUrl = `${domain}${parentPageFullSlug}/`;

  if (parentPageFullSlug && !parentPositionName)
    logger.warn(`No breadcrumbs position name for assigned parent story "${parentUrl}" on "${currentUrl}".`);

  const breadcrumbs = createBreadcrumbsSchema(
    firstElementUrl,
    breadcrumbsPositionName,
    currentUrl,
    parentPositionName,
    parentUrl
  );

  return <Schema schema={breadcrumbs} />;
};

export default BreadcrumbsSchema;
